<div class="product-image position-relative">
  <mercury-badge
    [badge]="badge"
    *ngFor="let badge of product?.meta?.badges"
  ></mercury-badge>

  <img
    height="400"
    width="416"
    [ngClass]="{
      nopad: product.type.includes('Sleeve')
    }"
    class="w-100 h-auto"
    [ngSrc]="product.image"
    ngSrcset="400w, 500w, 600w"
    [loaderParams]="{ aspect: 1.2, crop: false }"
  />
</div>
<div class="d-flex flex-column product-meta p-x">
  <div
    class="flex-column flex-lg-row d-flex justify-content-lg-between align-items-lg-center pt-2"
  >
    <div class="product-title h6 mb-0">
      {{ product.title | titleExtractor }}
    </div>

    <div class="product-prices d-flex flex-row">
      <div
        *ngIf="
          product.prices[currency]?.compare_at_price >
          product.prices[currency]?.price
        "
        class="price strike h6 mb-0"
      >
        {{ product.prices[currency].compare_at_price | currency }}
      </div>
      <div class="price h6 mb-0">
        {{ product.prices[currency]?.price | currency }}
      </div>
    </div>
  </div>
  <app-add-to-cart [_selectedVariant]="product.variants[0]"></app-add-to-cart>
</div>
